import { Streamdown } from "streamdown";
import { useEffect, useRef } from "react";
import type { StreamdownProps } from "streamdown";
import { cn } from "@/lib/utils";

export function StreamdownWrapper(props: StreamdownProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      // Find any child element that has data attribute "data-streamdown=code-block" and add class "not-prose" to it
      const codeBlocks = ref.current.querySelectorAll(
        "[data-streamdown=code-block]",
      );
      codeBlocks.forEach((codeBlock) => {
        codeBlock.classList.add("not-prose");
      });
    }
  }, []);

  return (
    <div ref={ref} className="w-full">
      <Streamdown
        controls={false}
        shikiTheme={["github-light", "github-dark"]}
        className={cn("streamdown-wrapped", props.className)}
        {...props}
      />
    </div>
  );
}
